import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ViewerDocument } from 'src/app/_shared/components/viewer-document/viewer-document.component';
import cloneDeep from 'lodash-es/cloneDeep';

@Component({
    selector: 'app-viewers-container',
    templateUrl: './viewers-container.component.html',
    styleUrls: ['./viewers-container.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ViewersContainerComponent implements OnInit {

    @Input() viewerDocumentsList: ViewerDocument[];

    @Output() closeContainer = new EventEmitter<void>();

    tabControl = new UntypedFormControl(0);

    displayedViewerDocumentsList: ViewerDocument[] = [];

    constructor() {
    }

    closeTab(index: number) {
        this.displayedViewerDocumentsList.splice(index, 1);

        if (this.displayedViewerDocumentsList.length === 0) {
            this.close();
        } else if (this.tabControl.value === this.displayedViewerDocumentsList.length) {
            this.tabControl.patchValue(this.displayedViewerDocumentsList.length - 1);
        }
    }

    close() {
        this.closeContainer.emit();
    }

    ngOnInit() {
        this.displayedViewerDocumentsList = cloneDeep(this.viewerDocumentsList);
    }

}
